module.exports = __webpack_public_path__ + "img/jiangbei.0eaf49f.png";